import React from 'react';
import * as S from '../styles';

type EpisodeTitleProps = {
  children: React.ReactNode;
};

const EpisodeTitle: React.FC<EpisodeTitleProps> = ({ children }) => (
  <S.Title>
    <strong>{children}</strong>
  </S.Title>
);
export default EpisodeTitle;
